import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { toast } from 'react-toastify';
import { format } from 'date-fns';
import { it } from 'date-fns/locale';
import { getLaboratori, createPrenotazione } from './api/api.private.service';
import { getMediaLink } from './api/utils';

const BookingPage = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const [selectedDate, setSelectedDate] = useState();
  const [selectedSlots, setSelectedSlots] = useState([]);
  const [availableDates, setAvailableDates] = useState([]);
  const [availableSlots, setAvailableSlots] = useState([]);
  const [labInfo, setLabInfo] = useState(null);
  const [selectedExperiment, setSelectedExperiment] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchLaboratori = async () => {
      try {
        const data = await getLaboratori();
        const lab = data.data.find(lab => lab.id === parseInt(id));
        setLabInfo(lab);
        if (lab && lab.esperimentis.length > 0) {
          const exp = lab.esperimentis.find(exp => exp.id === parseInt(searchParams.get('esp')));
          setSelectedExperiment(exp);
        }
      } catch (error) {
        console.error('Error fetching laboratori:', error);
      }
    };

    fetchLaboratori();
  }, [id]);

  useEffect(() => {
    if (selectedExperiment) {
      setAvailableDates(Object.keys(selectedExperiment.disponibilita.slots))
      setAvailableSlots(selectedExperiment.disponibilita.slots);
    }
  }, [selectedExperiment]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setSelectedSlots([]);
  };

  const handleSlotClick = (slot) => {
    if (selectedSlots.includes(slot)) {
      setSelectedSlots(selectedSlots.filter(s => s !== slot));
    } else if (selectedSlots.length < 3) {
      setSelectedSlots([...selectedSlots, slot]);
    }
  };

  const handleConfirmBooking = async () => {
    try {
      await createPrenotazione(
        format(selectedDate, 'yyyy-MM-dd'),
        selectedSlots,
        selectedExperiment.id
      );
      toast.success('Prenotazione aggiunta con successo!');
      navigate('/my-bookings');
    } catch (error) {
      console.error('Error saving booking:', error);
        toast.error('Operazione fallita. Riprova');
    }
  };

  const changeExpirement = (expId) => {
    const exp = labInfo.esperimentis.find(exp => exp.id === parseInt(expId));
    setSelectedExperiment(exp);
  }

  const isDateAvailable = (date) => {
    const dateString = format(date, 'yyyy-MM-dd');
    return availableDates.includes(dateString);
  };

  const getAvailableSlotsForDate = (date) => {
    if(!date) return [];
    const dateString = format(date, 'yyyy-MM-dd');
    return availableSlots[dateString] || [];
  };

  return (
    <div className="min-h-screen">
      <Navbar />
        <section
          className="text-center py-20"
          style={{
            backgroundImage: 'url("/header.png")',
            backgroundSize: 'cover',
            backgroundPosition: 'bottom',
          }}
        >
          <h2 className="text-4xl font-extrabold text-gray-800 font-space bg-white bg-opacity-75 inline-block px-4 py-2">
            [ Prenota un esperimento ]
          </h2>
        </section>
        {labInfo && (
          <div className="max-w-4xl mx-auto bg-white p-6 shadow-md mb-6">
            <div className="flex flex-col md:flex-row">
              <img
                src={getMediaLink(labInfo.immagine?.url)}
                width={'200px'}
                alt={labInfo.nome}
              />
              <div className="text-left ml-4">
                <h2 className="text-2xl font-bold text-gray-800">{labInfo.nome}</h2>
                <p className="text-gray-600 mt-2">{labInfo.descrizione}</p>
              </div>
            </div>
            
            <div className="mt-4">
              <label htmlFor="experiment" className="block text-lg font-semibold text-gray-800">Seleziona Esperimento:</label>
              <select
                id="experiment"
                value={selectedExperiment.id}
                onChange={(e) => changeExpirement(e.target.value)}
                className="mt-2 block w-full p-2 border shadow-md"
              >
                {labInfo.esperimentis.map((exp, index) => (
                  <option key={index} value={exp.id}>{exp.titolo}</option>
                ))}
              </select>
              <div
                className="flex flex-col md:flex-row items-center p-4 mb-4 mt-4"
              >
                <img
                  src={getMediaLink(selectedExperiment.immagine?.url)}
                  className="w-32 h-32 object-cover mr-4"
                  alt={selectedExperiment.titolo}
                />
                <div className="text-left">
                  <h3 className="text-xl font-semibold text-gray-800 font-space">
                    {selectedExperiment.titolo}
                  </h3>
                  <p className="text-gray-600 mt-2">{selectedExperiment.descrizione}</p>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="max-w-4xl mx-auto bg-white p-6 shadow-md">
          <label htmlFor="experiment" className="block text-lg font-semibold text-gray-800">Seleziona una data:</label>
          <div className="flex justify-center items-center">
            <Calendar
              onChange={handleDateChange}
              value={selectedDate ? selectedDate : null}
              minDate={new Date()}
              tileDisabled={({ date }) => !isDateAvailable(date)}
            />
          </div>
          <div className="mt-4 text-center">
            {selectedDate && <h2 className="text-xl font-semibold text-gray-800">Giorno selezionato: {format(selectedDate, 'dd MMMM yyyy', { locale: it })}</h2>}
          </div>
          <div className="mt-6">
            {selectedDate && <h2 className="text-2xl font-bold text-gray-800">Seleziona gli slot</h2>}
            <div className="grid grid-cols-2 gap-4 mt-4">
              {getAvailableSlotsForDate(selectedDate).length === 0 ? <p>Nessuno slot disponibile</p> : null}
              {getAvailableSlotsForDate(selectedDate).map((slot, index) => (
                <button
                  key={index}
                  onClick={() => handleSlotClick(slot)}
                  className={`px-4 py-2 shadow-md ${selectedSlots.includes(slot) ? 'bg-[black] text-white' : 'bg-white text-black border-2 border-black'}`}
                >
                  {slot}
                </button>
              ))}
            </div>
            {selectedSlots?.length > 0 && 
              <button onClick={handleConfirmBooking} className="mt-6 block text-center px-4 py-2 shadow-md bg-white text-black border-2 border-black hover:bg-black hover:text-white uppercase text-sm font-semibold">
                <i className="fas fa-check mr-2"></i> Conferma prenotazione
              </button>
            }
            
          </div>
        </div>
      <Footer />
    </div>
  );
};

export default BookingPage;